import { FC } from 'react';
import { Alert } from 'roo-ui/components';

interface NonMemberInfoProps {
  bookingId?: string;
}

const NonMemberInfo: FC<NonMemberInfoProps> = ({ bookingId }) => {
  if (bookingId) return null;

  return (
    <Alert variant="error" icon={{ name: 'info' }}>
      Not a Frequent Flyer member? Access Self Service by clicking the &quot;Manage your Booking&quot; link in your Qantas Hotels Booking
      Confirmation email.
    </Alert>
  );
};

export default NonMemberInfo;
